/* global BX, CatalogCardState */

(function () {
    const activeFavoriteSvg =
        '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="34" height="34" rx="17" fill="#2059B0"/><path d="M12.1796 17.5927L17 22.4401L21.8204 17.5927M17 22.4401L11.8783 17.2898C10.5472 15.9512 10.5472 13.781 11.8783 12.4424C13.2095 11.1039 15.6689 11.3661 17 12.7047C18.3311 11.3661 20.7906 11.1039 22.1217 12.4424C23.4528 13.781 23.4528 15.9512 22.1217 17.2898L17 22.4401Z" stroke="white" stroke-width="1.36" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const activeCompareSvg =
        '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="34" height="34" rx="17" fill="#2059B0"/><path d="M12.92 22.4399L12.92 11.5599M17 22.4399L17 15.6399M21.08 22.4399L21.08 19.7199" stroke="white" stroke-width="1.36" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function storeOriginalSvg(button) {
        if (!button.originalSvgStored) {
            const svgElement = button.querySelector('svg');
            if (svgElement) {
                button.originalSvg = svgElement.outerHTML;
                button.originalSvgStored = true;
            }
        }
    }

    function setButtonActive(button, isActive) {
        if (isActive) {
            button.classList.add('active');
            if (button.classList.contains('catalog-card__favorite')) {
                button.innerHTML = activeFavoriteSvg;
            } else if (button.classList.contains('catalog-card__compare')) {
                button.innerHTML = activeCompareSvg;
            }
        } else {
            button.classList.remove('active');
            if (button.originalSvg) {
                button.innerHTML = button.originalSvg;
            }
        }
    }

    function updateButtonFromState(button) {
        const card = button.closest('#product-info-block');
        if (!card) return;
        const productId = card.getAttribute('data-product-id');
        if (!productId) return;

        storeOriginalSvg(button);

        const isFavorite = button.classList.contains('catalog-card__favorite');
        const list = isFavorite ? CatalogCardState.delay : CatalogCardState.compare;
        const isActive = productId in list;

        setButtonActive(button, isActive);
    }

    async function sendRequest(productId, iblockId, type, button, wasActive) {
        let url;
        if (type === 'favorite') {
            url = `/ajax/item.php?item=${productId}&wish_item=Y&offers=N&iblockID=${iblockId}&quantity=1`;
        } else {
            url = `/ajax/item.php?item=${productId}&compare_item=Y&iblock_id=${iblockId}`;
        }
        await fetch(url, {method: 'GET', credentials: 'same-origin'})
            .then((response) => {
                if (!response.ok) throw new Error();
            })
            .catch(() => {
                setButtonActive(button, wasActive);
            });
    }

    async function onButtonClick(event) {
        const button = event.currentTarget;
        const card = button.closest('#product-info-block');
        if (!card) return;
        const productId = card.getAttribute('data-product-id');
        const iblockId = card.getAttribute('data-iblock-id');
        if (!productId || !iblockId) return;

        const wasActive = button.classList.contains('active');
        const newActive = !wasActive;

        setButtonActive(button, newActive);

        const type = button.classList.contains('catalog-card__favorite') ? 'favorite' : 'compare';
        await sendRequest(productId, iblockId, type, button, wasActive);
        if (window.BX?.onCustomEvent) {
            BX.onCustomEvent('onCompleteAction', [{action: 'loadBasket'}]);
        }
    }

    function syncUI() {
        const favoritesBtn = document.querySelectorAll('#btn-favorite');
        const comparesBtn = document.querySelectorAll('#btn-compare');

        favoritesBtn.forEach((btn) => updateButtonFromState(btn));
        comparesBtn.forEach((btn) => updateButtonFromState(btn));
    }

    function initButtons() {
        syncUI();
        document.querySelectorAll('#btn-favorite, #btn-compare').forEach((btn) => {
            btn.removeEventListener('click', onButtonClick);
            btn.addEventListener('click', onButtonClick);
        });
    }

    CatalogCardState.onReady(() => {
        initButtons();
        CatalogCardState.addUpdateListener(syncUI);
    });
})();
